import * as React from "react";
import Snackbar, { SnackbarOrigin } from "@mui/material/Snackbar";
import { useEffect } from "react";

export interface State extends SnackbarOrigin {
  open: boolean;
}

export interface SnackBarModel {
  openSnackBar: boolean;
  msg: string;
  autoHideDuration: number | null;
}

interface IProps {
  snackBarModel: SnackBarModel;
}

const SnackBar: React.FC<IProps> = ({ snackBarModel }) => {
  const [snackBarState, setSnackBarState] = React.useState<State>({
    open: false,
    vertical: "top",
    horizontal: "center",
  });
  const { vertical, horizontal, open } = snackBarState;

  useEffect(() => {
    setSnackBarState({
      open: snackBarModel.openSnackBar,
      vertical: "top",
      horizontal: "center",
    });
  }, [snackBarModel.openSnackBar]);

  const handleClose = () => {
    setSnackBarState({ ...snackBarState, open: false });
  };

  return (
    <div>
      <Snackbar
        anchorOrigin={{ vertical, horizontal }}
        open={open}
        autoHideDuration={snackBarModel.autoHideDuration}
        onClose={handleClose}
        message={snackBarModel.msg}
        key={vertical + horizontal}
      />
    </div>
  );
};

export default SnackBar;
